<input
  type="radio"
  class="btn-check"
  [id]="internalId"
  [value]="value"
  [disabled]="isDisabled"
  [checked]="isChecked"
  (click)="onClickRadio()"
/>
<label
  [for]="internalId"
  class="
    btn btn-outline btn-outline-dashed btn-outline-default
    d-flex align-items-center
    p-7
  "
>
  <span
    *ngIf="iconPath"
    [inlineSVG]="iconPath"
    class="svg-icon svg-icon-primary"
    [ngClass]="iconSizeClass"
  ></span>
  <span class="d-block fw-bold text-start">
    <span class="text-dark fw-bolder d-block fs-4">
      {{ title }}
    </span>
    <span *ngIf="description" class="text-gray-400 fs-6 mt-2">
      {{ description }}
    </span>
  </span>
</label>
